// extracted by mini-css-extract-plugin
export var section = "textAndButton-module--section--2sTn4";
export var text = "textAndButton-module--text--3hMjz";
export var button = "textAndButton-module--button--3YlTh";
export var line = "textAndButton-module--line--UlU0i";
export var label = "textAndButton-module--label--2LjXJ";